/**
 * Shopify-safe DOMPurify defaults for Dawn/LiveWire section HTML.
 * Requires the vendored asset `dompurify.min.js` (loaded before this file).
 * Custom elements (web components) are kept; executable markup is stripped.
 */
(function (window) {
  if (typeof DOMPurify === 'undefined') return;

  const ALLOWED_IFRAME_ORIGINS = [
    'https://www.youtube.com',
    'https://www.youtube-nocookie.com',
    'https://player.vimeo.com',
  ];

  DOMPurify.setConfig({
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'target',
      'loading',
      'decoding',
      'fetchpriority',
      'srcset',
      'sizes',
      'media',
      'playsinline',
      'allow',
      'allowfullscreen',
      'frameborder',
      'poster',
      'slot',
      'part',
      'inert',
    ],
    CUSTOM_ELEMENT_HANDLING: {
      tagNameCheck: (tagName) => tagName.includes('-'),
      attributeNameCheck: () => true,
      allowCustomizedBuiltInElements: true,
    },
  });

  DOMPurify.addHook('uponSanitizeElement', (node, data) => {
    if (data.tagName !== 'iframe' || !node.getAttribute) return;
    const src = node.getAttribute('src');
    if (!src) {
      node.remove();
      return;
    }
    try {
      const origin = new URL(src, window.location.href).origin;
      if (!ALLOWED_IFRAME_ORIGINS.includes(origin)) node.remove();
    } catch (e) {
      node.remove();
    }
  });
})(window);
